/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
    CriteriaToJSONTyped,
} from './Criteria';

/**
 * 
 * @export
 * @interface CriteriaCategory
 */
export interface CriteriaCategory {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    criteria?: Array<Criteria>;
}

/**
 * Check if a given object implements the CriteriaCategory interface.
 */
export function instanceOfCriteriaCategory(value: object): value is CriteriaCategory {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CriteriaCategoryFromJSON(json: any): CriteriaCategory {
    return CriteriaCategoryFromJSONTyped(json, false);
}

export function CriteriaCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'name': json['name'],
        'criteria': json['criteria'] == null ? undefined : ((json['criteria'] as Array<any>).map(CriteriaFromJSON)),
    };
}

export function CriteriaCategoryToJSON(json: any): CriteriaCategory {
    return CriteriaCategoryToJSONTyped(json, false);
}

export function CriteriaCategoryToJSONTyped(value?: CriteriaCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'name': value['name'],
        'criteria': value['criteria'] == null ? undefined : ((value['criteria'] as Array<any>).map(CriteriaToJSON)),
    };
}

